import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../state";

export interface MenuData {
  page: string;
}

const initialState: MenuData = {
  page: "home",
};

export const menuSlice = createSlice({
  name: "menuSlice",
  initialState,
  reducers: {
    setSelectedPage: (state, action) => {
      return {
        page: action.payload.page,
      };
    },
    cleanSelectedPage: (state) => {
      return initialState;
    },
  },
});

export const selectDialogs = (state: RootState) => state.dialog.dialogs;

export const { setSelectedPage, cleanSelectedPage } = menuSlice.actions;
export default menuSlice.reducer;
